import React from 'react'
import { useDropzone } from 'react-dropzone';

export default function DragDrop({onDrop}) {
    const { getRootProps, getInputProps, open } = useDropzone({
        accept: {
          "font/ttf": [".ttf"],
          "font/otf": [".otf"],
          "font/woff": [".woff"],
          "font/woff2": [".woff2"],
        },
        multiple: true,
        noClick: true,
        noKeyboard: true,
        onDrop,
      });
  return (
    <>
      <div className="uploadFontNoData dragingFont">
               <div className="fontUploadButton">
              <div {...getRootProps()}>
                {/* Hidden file input */}
                
              <img
                src={"/assets/images/uploadFontsIcon.svg"}
                alt="No Font Found"
                className="no-data-img"
                onClick={open}
              />
              <input {...getInputProps()} />
              <h3 onClick={open}>Drag and drop files to upload</h3>
              <p onClick={open}>
                A maximum of 10 fonts can be uploaded at a time. Supported
                formats: TTF, OTF, WOFF, or WOFF2.
              </p>
              </div>
            </div>
              </div>
    </>
  )
}
